import { createSlice } from '@reduxjs/toolkit';
import { createFilterInitialState, filterReducers } from 'common/utils/sliceUtils/filterSliceUtils';

import type { RootState } from '../../app/store';

const userGroupRoleMembershipSlice = createSlice({
    name: 'userGroupRoleMembership',
    initialState: createFilterInitialState(),
    reducers: () => ({
        ...filterReducers,
    })
});

// eslint-disable-next-line no-restricted-syntax
export default userGroupRoleMembershipSlice.reducer;
export const { addNewFilter, removeFilter, clearFilters } = userGroupRoleMembershipSlice.actions;
export const selectFilters = (state: RootState) => state.userGroupRoleMembership.filters;
